import { I18n } from '@affine/i18n';
import { registerRemotePresenceTranslator } from '@blocksuite/affine/shared/utils';

registerRemotePresenceTranslator(label =>
  label === 'crewmate'
    ? I18n.t('com.streamlain.marketplace.card.type.agent')
    : I18n.t('com.streamlain.share-menu.member-management.guest-badge')
);
